import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "form-sender-company" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  class: "font-bold text-lg",
  for: "sendingCompanyId"
}, "Detail Data Pengirim", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8"
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-lg mb-4" }, "Detail Pengirim :", -1)
const _hoisted_8 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "penerimaId" }, "Pilih Alamat Pengirim", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = {
  key: 1,
  class: "mb-4 px-3"
}
const _hoisted_12 = { class: "mb-6 p-col-12" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "",
  for: "namaPengirimId"
}, "Pengirim", -1)
const _hoisted_14 = {
  key: 0,
  class: "mt-1 font-semibold"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = { class: "mb-6 p-col-12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  class: "",
  for: "noTelpId"
}, "No. Telp Pengirim", -1)
const _hoisted_19 = {
  key: 0,
  class: "mt-1 font-semibold"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = { class: "mb-2 p-col-12" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Alamat Pengirim", -1)
const _hoisted_24 = { class: "mt-1 font-semibold" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-lg mb-4" }, "Detail Penerima :", -1)
const _hoisted_27 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  class: "ml-3",
  for: "isManualAddress"
}, "Input Alamat Manual", -1)
const _hoisted_29 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("label", { for: "penerimaId" }, "Pilih Alamat Penerima", -1)
const _hoisted_31 = {
  key: 0,
  class: "p-error"
}
const _hoisted_32 = {
  key: 1,
  class: "p-error"
}
const _hoisted_33 = { class: "mb-4 px-3" }
const _hoisted_34 = {
  key: 0,
  class: "mb-6 p-col-12"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("label", {
  class: "",
  for: "namaPenerimaId"
}, "Penerima", -1)
const _hoisted_36 = {
  key: 0,
  class: "mt-1 font-semibold"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  class: "p-error"
}
const _hoisted_39 = {
  key: 1,
  class: "mb-6 p-col-12"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("label", {
  class: "",
  for: "noTelpId"
}, "No. Telp Penerima", -1)
const _hoisted_41 = {
  key: 0,
  class: "mt-1 font-semibold"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = {
  key: 2,
  class: "mb-2 p-col-12"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Alamat Penerima", -1)
const _hoisted_46 = {
  key: 0,
  class: "mt-1 font-semibold"
}
const _hoisted_47 = {
  key: 2,
  class: "p-error"
}
const _hoisted_48 = {
  key: 3,
  class: "p-error"
}
const _hoisted_49 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("label", {
  for: "scheduleId",
  class: ""
}, "Pilih Jadwal Penjemputan Kurir", -1)
const _hoisted_51 = { class: "action-button mt-5" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Selanjutnya")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", null, [
      (!_ctx.isMiisi)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Multiselect, {
              id: "sendingCompanyId",
              class: "mt-1 rounded-lg",
              "allow-empty": true,
              "clear-on-select": true,
              modelValue: _ctx.v$.sendingCompanyId.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.sendingCompanyId.$model = $event)),
              placeholder: "Pilih Perusahaan",
              options: _ctx.sendingCompanyOption,
              searchable: true,
              disabled: _ctx.isMiisi
            }, null, 8, ["modelValue", "options", "disabled"]),
            ((_ctx.v$.sendingCompanyId.$invalid && _ctx.submitted) || _ctx.v$.sendingCompanyId.$pending.$response
          )
              ? (_openBlock(), _createBlock("small", _hoisted_4, _toDisplayString(_ctx.v$.sendingCompanyId.required.$message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.dataForm.sendingCompanyId)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              (!_ctx.isMiisi)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      id: "penerimaId",
                      class: "mt-1",
                      modelValue: _ctx.v$.sendingAddressId.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.sendingAddressId.$model = $event)),
                      placeholder: "Pilih Pengirim",
                      options: _ctx.companyAdressOption,
                      searchable: true,
                      onInput: _ctx.updateReceive,
                      disabled: _ctx.isMiisi
                    }, null, 8, ["modelValue", "options", "onInput", "disabled"]),
                    ((_ctx.v$.sendingAddressId.$invalid && _ctx.submitted) ||
          _ctx.v$.sendingAddressId.$pending.$response || (_ctx.submitted && _ctx.v$.sendingAddressId.$model === 0)
          )
                      ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.sendingAddressId.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dataForm.sendingAddressId || _ctx.isMiisi)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      (_ctx.isMiisi)
                        ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.dataForm.nameSender), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_15, [
                            _createVNode(_component_InputText, {
                              id: "namaPengirimId",
                              class: "input-primary mt-1 w-full rounded-lg",
                              name: "name",
                              modelValue: _ctx.v$.nameSender.$model,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.nameSender.$model = $event)),
                              type: "text",
                              placeholder: "Tulis Nama Pengirim",
                              disabled: _ctx.isMiisi
                            }, null, 8, ["modelValue", "disabled"]),
                            ((_ctx.v$.nameSender.$invalid && _ctx.submitted) || _ctx.v$.nameSender.$pending.$response)
                              ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.nameSender.required.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (_ctx.isMiisi)
                        ? (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.dataForm.telpSender), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode(_component_InputText, {
                              id: "noTelpId",
                              class: "input-primary mt-1 w-full rounded-lg",
                              name: "telp",
                              modelValue: _ctx.v$.telpSender.$model,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.telpSender.$model = $event)),
                              type: "number",
                              placeholder: "Tulis No. Telp Pengirim",
                              disabled: _ctx.isMiisi
                            }, null, 8, ["modelValue", "disabled"]),
                            ((_ctx.v$.telpSender.$invalid && _ctx.submitted) || _ctx.v$.telpSender.$pending.$response)
                              ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.telpSender.required.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode("p", _hoisted_24, _toDisplayString(_ctx.dataForm.addressSender), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              (!_ctx.isMiisi)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _createVNode(_component_Checkbox, {
                      inputId: "isManualAddress",
                      binary: true,
                      modelValue: _ctx.isManualAddress,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isManualAddress = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeInputRecieverAddress())),
                      disabled: _ctx.isMiisi
                    }, null, 8, ["modelValue", "disabled"]),
                    _hoisted_28
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isManualAddress)
                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_Multiselect, {
                      id: "penerimaId",
                      class: "mt-1",
                      modelValue: _ctx.v$.receiverAddressId.$model,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.receiverAddressId.$model = $event)),
                      placeholder: "Pilih Penerima",
                      options: _ctx.companyAdressOption,
                      onInput: _ctx.updateValueAddress,
                      disabled: _ctx.isMiisi
                    }, null, 8, ["modelValue", "options", "onInput", "disabled"]),
                    ((_ctx.v$.receiverAddressId.$invalid && _ctx.submitted) && _ctx.v$.sendingAddressId.$model === _ctx.v$.receiverAddressId.$model && _ctx.v$.receiverAddressId.$model != 0)
                      ? (_openBlock(), _createBlock("small", _hoisted_31, _toDisplayString(_ctx.v$.receiverAddressId.mustNotSame.$message), 1))
                      : (_ctx.submitted && _ctx.v$.receiverAddressId.$model == 0)
                        ? (_openBlock(), _createBlock("small", _hoisted_32, _toDisplayString('Penerima harus diisi')))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_33, [
                ((_ctx.dataForm.receiverAddressId && !_ctx.isManualAddress) || _ctx.isManualAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      _hoisted_35,
                      (_ctx.isMiisi)
                        ? (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(_ctx.dataForm.nameReceiver), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_37, [
                            _createVNode(_component_InputText, {
                              id: "namaPenerimaId",
                              class: "input-primary mt-1 w-full rounded-lg",
                              name: "name",
                              modelValue: _ctx.v$.nameReceiver.$model,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.nameReceiver.$model = $event)),
                              type: "text",
                              placeholder: "Tulis Nama Penerima",
                              disabled: _ctx.isMiisi
                            }, null, 8, ["modelValue", "disabled"]),
                            ((_ctx.v$.nameReceiver.$invalid && _ctx.submitted) || _ctx.v$.nameReceiver.$pending.$response)
                              ? (_openBlock(), _createBlock("small", _hoisted_38, _toDisplayString(_ctx.v$.nameReceiver.required.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.dataForm.receiverAddressId && !_ctx.isManualAddress) || _ctx.isManualAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_39, [
                      _hoisted_40,
                      (_ctx.isMiisi)
                        ? (_openBlock(), _createBlock("p", _hoisted_41, _toDisplayString(_ctx.dataForm.addressSender), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_42, [
                            _createVNode(_component_InputText, {
                              id: "noTelpId",
                              class: "input-primary mt-1 w-full rounded-lg",
                              name: "telp",
                              modelValue: _ctx.v$.telpReceiver.$model,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.telpReceiver.$model = $event)),
                              type: "number",
                              placeholder: "Tulis No. Telp Penerima",
                              disabled: _ctx.isMiisi
                            }, null, 8, ["modelValue", "disabled"]),
                            ((_ctx.v$.telpReceiver.$invalid && _ctx.submitted) || _ctx.v$.telpReceiver.$pending.$response)
                              ? (_openBlock(), _createBlock("small", _hoisted_43, _toDisplayString(_ctx.v$.telpReceiver.required.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.dataForm.receiverAddressId && !_ctx.isManualAddress) || _ctx.isManualAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_44, [
                      _hoisted_45,
                      (!_ctx.isManualAddress || _ctx.isMiisi)
                        ? (_openBlock(), _createBlock("p", _hoisted_46, _toDisplayString(_ctx.dataForm.addressReceiver), 1))
                        : (_openBlock(), _createBlock(_component_Textarea, {
                            key: 1,
                            id: "alamatPenerima",
                            modelValue: _ctx.v$.addressReceiver.$model,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.addressReceiver.$model = $event)),
                            class: "mt-3 input-primary w-full rounded-lg",
                            rows: "2",
                            placeholder: "Alamat Penerima",
                            disabled: _ctx.isMiisi
                          }, null, 8, ["modelValue", "disabled"])),
                      ((_ctx.v$.addressReceiver.$invalid && _ctx.submitted) || _ctx.v$.addressReceiver.$pending.$response
          )
                        ? (_openBlock(), _createBlock("small", _hoisted_47, _toDisplayString(_ctx.v$.addressReceiver.required.$message), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Textarea, {
                        id: "alamatPenerimaId",
                        modelValue: _ctx.v$.notesReceiver.$model,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.notesReceiver.$model = $event)),
                        class: "mt-3 input-primary w-full rounded-lg",
                        rows: "2",
                        placeholder: "Keterangan Alamat"
                      }, null, 8, ["modelValue"]),
                      ((_ctx.v$.notesReceiver.$invalid && _ctx.submitted) || _ctx.v$.notesReceiver.$pending.$response
          )
                        ? (_openBlock(), _createBlock("small", _hoisted_48, _toDisplayString(_ctx.v$.notesReceiver.required.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.dataForm.receiverAddressId || _ctx.isManualAddress) && _ctx.isDooring)
        ? (_openBlock(), _createBlock("div", _hoisted_49, [
            _createVNode("div", null, [
              _hoisted_50,
              _createVNode(_component_Multiselect, {
                id: "scheduleId",
                class: "mt-1 w-full",
                "allow-empty": false,
                "clear-on-select": false,
                modelValue: _ctx.dataForm.pickupScheduleId,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataForm.pickupScheduleId = $event)),
                placeholder: "Pilih Jam",
                options: _ctx.scheduleOption,
                searchable: true
              }, null, 8, ["modelValue", "options"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_51, [
        _createVNode(_component_Button, {
          class: "btn-primary text-black mr-3 px-10 py-1",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
        }, {
          default: _withCtx(() => [
            _hoisted_52
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black px-10 py-1",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitBack()))
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        })
      ])
    ])
  ]))
}